import { render } from "./MonitorVehicle.vue?vue&type=template&id=97f41810"
import script from "./MonitorVehicle.vue?vue&type=script&lang=js"
export * from "./MonitorVehicle.vue?vue&type=script&lang=js"

import "./MonitorVehicle.vue?vue&type=style&index=0&id=97f41810&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"
script.render = render

export default script